import React from 'react';
import './style.scoped.scss';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../assets/constants/strings';

const Revealr = ({ handleSummary, isSummary, currentDoc }) => {
  return (
    <div className='d-flex flex-column'>
      {currentDoc && currentDoc.summary !== null && (
        <span
          className='revealBtn wf-card__item--clickable'
          onClick={() => handleSummary(isSummary ? 'main' : 'Summary')}
        >
          <b>{isSummary ? 'View Source Document' : 'View Summary'}</b>
        </span>
      )}
      <Link to={ROUTES.QUERY}>
        <span className='revealBtn wf-card__item--clickable'>
          <b>Query Document</b>
        </span>
      </Link>
    </div>
  );
};

export default Revealr;
